import { helpers, required } from '@vuelidate/validators';
import { trans } from '../../../../_00_elements/translation';
import { commonPayAccountRules } from './commonPayAccountRules';

// eslint-disable-next-line import/prefer-default-export
export const getPayAccountValidator = () => ({
  company_name: {
    required: helpers.withMessage(
      () => trans('gestion.pay.informations.legal_name.error.required'),
      required,
    ),
  },
  ...commonPayAccountRules,
});
